const initialState = {
  saving: false,
  deleting: false,
  adding: false,
  edit: false,
  loading: true,
  translationSites: {},
  addedLanguageName: '',
  tab: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'LOAD_TRANSLATIONS': {
      const { hash, ...data } = action.payload;

      const languages = Object.keys(data);

      return {
        ...state,
        hash,
        languages,
        originalSets: data,
        sets: data,
        tab: (languages.includes(state.tab) ? state.tab : languages[0]),
        loading: false,
      };
    }
    case 'LOAD_TRANSLATION_SITES': {
      return { ...state, translationSites: action.payload };
    }
    case 'CHANGE_TRANSLATION_TAB':
      return { ...state, tab: action.payload };
    case 'UPDATE_TRANSLATION_OBJECT': {
      const {
        tab,
        title,
        section,
        formSection,
        newValue,
      } = action.payload;

      return {
        ...state,
        sets: {
          ...state.sets,
          [tab]: {
            ...state.sets[tab],
            [title]: {
              ...state.sets[tab][title],
              [section]: {
                ...state.sets[tab][title][section],
                [formSection]: newValue,
              },
            },
          },
        },
      };
    }
    case 'LOADING_TRANSITION_OBJECT':
      return { ...state, loading: action.payload };
    case 'SAVING_TRANSITION_OBJECT':
      return { ...state, saving: action.payload };
    case 'ADDING_LANGUAGE':
      return { ...state, adding: action.payload };
    case 'UPDATE_ADDED_LANGUAGE_NAME':
      return { ...state, addedLanguageName: action.payload };
    case 'DELETING_LANGUAGE':
      return { ...state, deleting: action.payload };
    case 'EDIT_TRANSITION_OBJECT':
      return { ...state, edit: action.payload };
    case 'RESET_TRANSITION_OBJECT': {
      const originalValue = state.originalSets;
      return { ...state, sets: originalValue };
    }
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
